import { Component, DebugElement} from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController,LoadingController,Platform } from 'ionic-angular';
import { Button } from 'ionic-angular/components/button/button';
import { UUID } from 'angular2-uuid';
import { MesasProvider } from '../../providers/mesas/mesas'
import { Storage } from '@ionic/storage';
import { ElectronService } from 'ngx-electron';
import { CajaProvider } from '../../providers/caja/caja'
import { Observable } from 'rxjs/Observable';
import { Subscription } from "rxjs/Subscription";
import { MensajeProvider } from '../../providers/mensaje/mensaje'
import { visitAll } from '@angular/compiler';
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,GESTION_DOMICILIOS } from "../../config/url.servicio"
import { MeseroProvider } from '../../providers/mesero/mesero'
import { UsuariosProvider } from '../../providers/usuarios/usuarios'

@IonicPage()
@Component({
  selector: 'page-domicilios',
  templateUrl: 'domicilios.html',
  providers: [ AuthService,CompaniasProvider,MensajeProvider,
    CajaProvider,MesasProvider,ElectronService ]
})
export class DomiciliosPage {

  listaMuestra = []
  actualizar = []
  datatitle = []
  valortitle:string="meseros"

  listaGruposProductos = []
  listaGruposProductosMesa = []
  listaProductos = []
  listaProductosMesa = []
  clienteGenerico
  clienteGenericoMesa

  nombreFiltroGrupo
  filtroGruposActivo: boolean = false
  filtrogruposProductosId

  listaProductosSeleccionados = []

  valorTotalVenta = 0
  valorTotalProductos = 0
  valorTotalImpuestos = 0
  price = 0
  valorTotalDevolver = 0
  datosAdicionalesArrayMesero = []

  realizandoUnaVenta: boolean = false

  numeromesa
  numeromesaMostrar:any =""

  clienteId = []
  usuarioId = []
  domicilio:string = 'N'
  actualizando:boolean = false
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  datosDomicilio = []
  loader
  datosDomicilioTotalDia = []
  maximopedido = 0
  minimopedido = 0
  totalpedido = 0
  usuarios = []
  imprimir:boolean = true
  descripcion:string=""
  companiasId
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public alertControllers:AlertController,
              public servicioMesas:MesasProvider,
              public loaders:LoadingController,
              public storage:Storage,
              public servicio: CajaProvider,
              // public socket:Socket ,
              public servicioCompania:CompaniasProvider,
              public auth: AuthService,
              public platform: Platform,
              public servicioMesero:MeseroProvider,
              public servicioUsuario:UsuariosProvider
            ) {
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                    this.companiasId = val['companiasId']
                  }
                })
                this.iniciar()
              }

  ionViewDidLoad() {

  }

  searchSimple(cantidadafnSimple:any,item,index){
    setTimeout(() => {


        if(Number(cantidadafnSimple['_value'])==0 || isNaN(cantidadafnSimple['_value']) ){
         return
       }

    //    let cantidadactual = Number(item['cantidad'])
       let cantidad = Number(cantidadafnSimple['_value'])

       let nuevaCantidad = Number(cantidad)

       index = this.buscarIndex(item,index)
       let cantidadOld = this.listaProductosSeleccionados[index]['cantidad']
       let valorImpuesto = this.listaProductosSeleccionados[index]['valorImpuesto']
       let valorProducto = this.listaProductosSeleccionados[index]['valorProducto']
       let valorVenta =  this.listaProductosSeleccionados[index]['valorVenta']

       this.valorTotalImpuestos -= (valorImpuesto * cantidadOld)
       this.valorTotalProductos -= (valorProducto * cantidadOld)
       this.valorTotalVenta -= (valorVenta * cantidadOld)
       this.listaProductosSeleccionados[index]['cantidad'] = nuevaCantidad

       this.actualizarReal(item,index)
       let valorTotalVentaNum = 0

       valorTotalVentaNum = Number(this.valorTotalVenta) +  (Number(item['valorVenta']) * nuevaCantidad)
       this.valorTotalVenta = valorTotalVentaNum

       let valorTotalProductosNum = 0
       valorTotalProductosNum = Number(this.valorTotalProductos) + ( Number(item['valorProducto']) * nuevaCantidad)
       this.valorTotalProductos = valorTotalProductosNum
       let valorTotalImpuestosNum =  0
       valorTotalImpuestosNum =Number(this.valorTotalImpuestos) +  ( Number(item['valorImpuesto'])* nuevaCantidad)
       this.valorTotalImpuestos = valorTotalImpuestosNum




     //  this.aumentarUnProducto(item, index)
       item = {}
       cantidadafnSimple['_value'] = ''
    //    let nuevacantidad = cantidadactual +  cantidad
    //    this.cantidadActual = cantidadactual
    //    this.cantidad = cantidad
    //    this.nuevacantidad = nuevacantidad
    //    this.productosElaboradosSimple[index]['cantidad'] =  this.nuevacantidad
    //    cantidadafnSimple['_value'] = 0
    //    this.mymodelSimple = null
    // this.actualizarReal(item,index)

     },1000)
   }


   buscarIndex(item:any,index:any){
    let id  = Number(index)

    let tipoProducto  = item['tipoProducto']
    let productosId = item['productosId']
    let indexNuevo = 0

    // for(let i =0;i <this.listaProductos.length;i++){
    //   if(i == id && this.listaProductos[i].tipoProducto == tipoProducto){
    //       for(let k = 0;k < this.listaProductosSeleccionados.length;k++){
    //         if(this.listaProductosSeleccionados[k].productosId == this.listaProductos[i].productosId && this.listaProductosSeleccionados[k].tipoProducto == tipoProducto){
    //             indexNuevo = k
    //             k = this.listaProductosSeleccionados.length + 1
    //         }
    //         }
    //         i = this.listaProductos.length + 1
    //       }

    //   }

            for(let k = 0;k < this.listaProductosSeleccionados.length;k++){
              if(this.listaProductosSeleccionados[k].productosId == productosId && this.listaProductosSeleccionados[k].tipoProducto == tipoProducto){
                  indexNuevo = k
                  k = this.listaProductosSeleccionados.length + 1
              }
              }


    return indexNuevo
  }


  imprimirDomicilio(codigo:any){
    // if(this.imprimir){
      this.storage.get('companiasId').then((val) => {

        let descripcion = this.descripcion
       if(descripcion===undefined){
        descripcion = ""
       }

      this.servicio.imprimirComanda(codigo,val,descripcion)
      .subscribe((data)=>{
        this.descripcion=""
        this.mostrarMensajeGeneral(data.json())
      },
       error=>{
         console.log(error)
       })
      })
    // }else{
    //   this.mostrarMensajes('Debe cambiar el valor para poder imprimir','Advertencia')
    //   return false
    // }
  }

  iniciar(){
    this.limpiar()
    this.buscarDatos()
    this.sacarMensajeBoton(100,'false','S')
    this.buscarDomicilios()
    this.buscarUsuarios()
  }

buscarUsuarios(){
  this.storage.get('companiasId').then((val)=>{
    this.servicioUsuario.buscarUsuarioPorEmpresa(val)
    .subscribe((items)=>{
      this.usuarios = items[0]
    }, (error)=>{
      console.log(error)
    })
  })

}
  buscarDomicilios(){
    this.storage.get('companiasId').then((val)=>{


    this.servicioMesero.buscarDomiciliosPorCompania(val)
    .subscribe((items)=>{

      this.datosDomicilio = items[0]

      this.datosDomicilioTotalDia = items[1]
      this.maximopedido = items[1][0].maximopedido
      this.minimopedido = items[1][0].minimopedido
      this.totalpedido = items[1][0].total


    }, (error)=>{
      console.log(error)
    })
  })

  }

  cancelarData(){
    this.iniciar()
  }

  buscarDomiciliosEmpty(){
    this.listaProductosSeleccionados=[]
    this.buscarDomicilios()
  }
  enviarMensaje(nombre:any,data:any) {
    // this.socket.emit(nombre, data);
  }
  ionViewWillLeave() {
    // this.socket.disconnect();
  }

  buscarDatos(){
    this.storage.get('companiasId').then((val)=>{
    this.servicioMesas.buscarMesasPorCompania(val)
    .subscribe(
      res => {

        for(var k = 0; k < res.length;k++){
          this.listaMuestra.push({
              'left':res[k].leftt,
              'width':res[k].width,
              'top':res[k].topp,
              'height':res[k].height,
              'id': res[k].id,
              'color': res[k].color,
              'Uuid': res[k].Uuid,
              'name' : "dataDynamicCrud",
              'queHago' : "I",
              'nombreTabla' : "mesas"
            })

        }
      },
      error => {
        console.log(error)
      }
    )
  })
    this.actualizar['valor']= true
    this.datatitle['valor'] = true
  }
  sacarMensajeBoton(id:any,queHago:string,domicilio:string){
    this.domicilio = domicilio
    this.actualizarData(id,queHago);
}
mostrarMensajes(mensaje,advertencia) {
  let alert = this.alertControllers.create({
    title: advertencia,
    subTitle: mensaje,
    buttons: ['Ok']
  });
  alert.present()
}
actualizarData(id:any,queHago:string){
  if(queHago=="false"){
    this.actualizar['valor']= false
    this.listaMuestra = []
    if(id==100){
      // this.numeromesa = id
      this.numeromesaMostrar = 'Domicilio'
    }else{
      this.numeromesa = id
      this.numeromesaMostrar = `Mesa # ${id}`
    }

    this.limpiar()
    this.buscarGruposProductosParaCaja(id)
  }else{
    this.actualizar['valor']= true
    this.buscarDatos()
    this.numeromesa = id
    this.numeromesaMostrar = `Mesa # ${id}`
  }
}
buscarGruposProductosParaCaja (id:any) {
  let valorid = id
  this.storage.get('companiasId').then((val) => {
      this.servicio.buscarGruposProductosParaCajaComandas(val).subscribe(
          res => {
              // this.listaGruposProductos = res[0]
              // this.listaProductos = res[1]
              this.valoresImagenes(res)
              this.clienteGenericoMesa = res[2]
              this.traerDatosGuardados(valorid)
          },
          err => {
              this.mostrarMensajeDeError('No se puedieron traer los grupos ni los productos, intente luego.')
          }
      )
  })
}

valoresImagenes(res:any){
  if(this.platform.is('android') || this.platform.is('ios')){

    let listaGruposProductosTemporal = []
    let resData = res[0]
    // let imgs = ''
    for(let k=0;k<resData.length;k++){
        let imagenNueva =resData[k].imagenLocal

        // imagenNueva = MODO_DESCONECTADO ? imagenNueva : imagenNueva.replace('file:///C:/bd/imagenes/','assets/imgs/')
        // /storage/emulated/0/DCIM
       // imagenNueva = MODO_DESCONECTADO ? imagenNueva : imagenNueva.replace('file:///C:/bd/imagenes/','assets/imgs/')
        listaGruposProductosTemporal.push({
            gruposProductosId:resData[k].gruposProductosId,
            codigoGrupoProducto:resData[k].codigoGrupoProducto,
            nombreGrupoProducto:resData[k].nombreGrupoProducto,
            companiasId:resData[k].companiasId,
            imagenLocal: imagenNueva,
            imagen:resData[k].imagen
        })
        // imgs = imagenNueva
    }
    // this.mostrarMensajeDeError('si entro por aca' + imgs)
    this.listaGruposProductos = listaGruposProductosTemporal

    let listaProductosTemporal = []
    let resProductoData = res[1]

    for(let y=0;y<resProductoData.length;y++){
        let imagenNueva =resProductoData[y].imagenLocal
        // /storage/emulated/0/DCIM
      //  imagenNueva = MODO_DESCONECTADO ? imagenNueva : imagenNueva.replace('file:///C:/bd/imagenes/','assets/imgs/')

        listaProductosTemporal.push({
            gruposProductosId:resProductoData[y].gruposProductosId,
            imagen:resProductoData[y].imagen,
            imagenLocal:imagenNueva,
            nombreProducto:resProductoData[y].nombreProducto,
            productosId:resProductoData[y].productosId,
            tipoProducto:resProductoData[y].tipoProducto,
            valorImpuesto:resProductoData[y].valorImpuesto,
            valorProducto:resProductoData[y].valorProducto,
            valorVenta:resProductoData[y].valorVenta
        })
    }

    this.listaProductos = listaProductosTemporal

 //   this.mostrarMensajeDeError('es android')
}else{

    // let listaGruposProductosTemporal = []
    // let resData = res[0]
    // for(let k=0;k<resData.length;k++){
    //     let imagenNueva =resData[k].imagenLocal
    //     imagenNueva = MODO_DESCONECTADO ? imagenNueva : imagenNueva.replace('file:///C:/bd/imagenes/','file:///C:/bd/imagenes/')
    //     listaGruposProductosTemporal.push({
    //         gruposProductosId:resData[k].gruposProductosId,
    //         codigoGrupoProducto:resData[k].codigoGrupoProducto,
    //         nombreGrupoProducto:resData[k].nombreGrupoProducto,
    //         companiasId:resData[k].companiasId,
    //         imagen:resData[k].imagen,
    //         imagenLocal: imagenNueva
    //     })
    // }
    // this.listaGruposProductos = listaGruposProductosTemporal

    // let listaProductosTemporal = []
    // let resProductoData = res[1]

    // for(let y=0;y<resProductoData.length;y++){

    //     let imagenNueva =resProductoData[y].imagenLocal
    //     imagenNueva = MODO_DESCONECTADO ? imagenNueva : imagenNueva.replace('file:///C:/bd/imagenes/','C:/bd/imagenes/')
    //     listaProductosTemporal.push({
    //         gruposProductosId:resProductoData[y].gruposProductosId,
    //         imagen:resProductoData[y].imagen,
    //         imagenLocal:imagenNueva,
    //         nombreProducto:resProductoData[y].nombreProducto,
    //         productosId:resProductoData[y].productosId,
    //         tipoProducto:resProductoData[y].tipoProducto,
    //         valorImpuesto:resProductoData[y].valorImpuesto,
    //         valorProducto:resProductoData[y].valorProducto,
    //         valorVenta:resProductoData[y].valorVenta
    //     })
    // }

    // this.listaProductos = listaProductosTemporal
               this.listaGruposProductos = res[0]
               this.listaProductos = res[1]


    // this.listaGruposProductos = res[0]
    console.log('no es android')
    //this.mostrarMensajeDeError('no es android')
}
}

traerDatosGuardados(id:any){
  let codigo = id
  this.storage.get('companiasId').then((val) => {
    this.servicio.buscarComandasDomicilio(codigo,val,'S')
    .subscribe((val)=>{
      this.listaProductosSeleccionados = []
      if(val.length>0){
        for(var k = 0;k < val.length;k++){
          if(codigo == val[k].codigo){
            this.listaProductosSeleccionados.push(val[k])
            this.valorTotalImpuestos += Number(val[k].valorImpuesto)
            this.valorTotalVenta += Number(val[k].valorTotalVenta)
            this.valorTotalProductos+= Number(val[k].valorProducto)
            this.valorTotalDevolver = Number(val[k].valorTotalVenta)
            this.valorTotalVenta = Number(val[k].valorTotalVenta)
            this.numeromesa = Number(val[k].numeromesa)
            this.actualizarReal(val[k],k)
            if(k + 1 == val.length){

              this.clienteId.push({'value':val[k].clientesId})
              this.usuarioId.push({'value':val[k].usuariosId})
              // this.requestAutocompleteItems(this.clienteId)
            }

          }
      }
        this.realizandoUnaVenta = true
        this.actualizando = true
      }
    },error =>{
      this.listaProductosSeleccionados = []
    })
})

}


Entregado(id:any,color:any){
  let codigo = id
  let Color= color
  this.storage.get('companiasId').then((val) => {
    this.servicio.ActualizarColorComandasDomicilio(codigo,val,Color)
    .subscribe((val)=>{
      this.listaProductosSeleccionados = []
      if(val.length>0){
        for(var k = 0;k < val.length;k++){
          if(codigo == val[k].codigo){
            this.listaProductosSeleccionados.push(val[k])
            this.valorTotalImpuestos += Number(val[k].valorImpuesto)
            this.valorTotalVenta += Number(val[k].valorTotalVenta)
            this.valorTotalProductos+= Number(val[k].valorProducto)
            this.valorTotalDevolver = Number(val[k].valorTotalVenta)
            this.valorTotalVenta = Number(val[k].valorTotalVenta)
            this.numeromesa = Number(val[k].numeromesa)
            this.actualizarReal(val[k],k)
            if(k + 1 == val.length){
              this.clienteId.push({'value':val[k].clientesId})
              this.usuarioId.push({'value':val[k].usuariosId})
              // this.requestAutocompleteItems(this.clienteId)
            }

          }
      }
        this.realizandoUnaVenta = true
        this.actualizando = true
      }
    },error =>{
      this.listaProductosSeleccionados = []
    })
})

}

mostrarMensajeDeError(mensaje) {
  let alert = this.alertControllers.create({
    title: 'Error',
    subTitle: mensaje,
    buttons: ['Cerrar']
  });
  alert.present();
}
filtrarProductos(item) {
  this.filtroGruposActivo = true
  this.nombreFiltroGrupo = item.nombreGrupoProducto
  this.filtrogruposProductosId = item.gruposProductosId
}
disminuirUnProducto(item, index) {


  let nuevaCantidad = Number(item['cantidad']) - 1

  if(nuevaCantidad <= 0){
    if(item['Uuid'] !==undefined){
      this.mostrarMensajes('El registro no se puede quitar verifique','Advertencia')
      return
    }else{
      this.listaProductosSeleccionados.splice(index, 1)

      if(this.listaProductosSeleccionados.length <= 0){
          this.realizandoUnaVenta = false
          this.actualizando = false
      }
    }



  }else{
    this.actualizarReal(item,index)
    this.listaProductosSeleccionados[index]['cantidad'] = nuevaCantidad
  }

  this.valorTotalVenta = this.valorTotalVenta - item['valorVenta']
  this.valorTotalProductos = this.valorTotalProductos - item['valorProducto']
  this.valorTotalImpuestos = this.valorTotalImpuestos - item['valorImpuesto']
}

aumentarUnProducto(item, index) {
  let nuevaCantidad = Number(item['cantidad']) + 1
  this.listaProductosSeleccionados[index]['cantidad'] = nuevaCantidad
  let valorVenta =  Number(item['valorVenta'])
  this.valorTotalVenta = this.valorTotalVenta + valorVenta
  let valorProducto = Number(item['valorProducto'])
  this.valorTotalProductos = this.valorTotalProductos + valorProducto
  let valorImpuesto = Number(item['valorImpuesto'])
  this.valorTotalImpuestos = this.valorTotalImpuestos + valorImpuesto
  this.actualizarReal(item,index)

}

actualizarReal(item:any,index:any){
  let id  = Number(item['productosId'])
  let tipoProducto  = item['tipoProducto']
  for(let i =0;i <this.listaProductos.length;i++){
    if(this.listaProductos[i].productosId == id && this.listaProductos[i].tipoProducto == tipoProducto){
      this.listaProductosSeleccionados[index]['valorImpuesto'] = this.listaProductos[i]['valorImpuesto']
      this.listaProductosSeleccionados[index]['valorProducto'] = this.listaProductos[i]['valorProducto']
      this.listaProductosSeleccionados[index]['queHago'] = true
      i = this.listaProductos.length + 1
    }
  }
}

agregarAlCarrito(item) {

  this.realizandoUnaVenta = true

  let productosId = item['productosId']

  let tipoProducto = item['tipoProducto']
  let contarProductosConElMismoId = this.listaProductosSeleccionados.filter( item => item.productosId === productosId && item.tipoProducto === tipoProducto )
  if(contarProductosConElMismoId.length > 0){
      return
  }

  item['cantidad'] = 1
  this.listaProductosSeleccionados.push(item)
  let valor = Number(item['valorVenta'])
  this.valorTotalVenta = this.valorTotalVenta + valor
  this.valorTotalProductos = this.valorTotalProductos + item['valorProducto']
  this.valorTotalImpuestos = this.valorTotalImpuestos + item['valorImpuesto']
}
quitarFiltroGrupos() {
  this.filtroGruposActivo = false,
  this.filtrogruposProductosId = undefined
  this.nombreFiltroGrupo = ''
}
DECIMAL_SEPARATOR  = '.'
GROUP_SEPARATOR = ','

format(valString) {
    if (!valString) {
        this.valorTotalDevolver = 0
        return '';
    }
    let val = valString.toString();
    try {
        this.valorTotalDevolver = Number(val.replace(/,/g, ''))
    } catch (e) {
        this.valorTotalDevolver = 0
    }

    const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
    return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
};

unFormat(val) {
    if (!val) {
        return '';
    }
    val = val.replace(/^0+/, '');

    if (this.GROUP_SEPARATOR === ',') {
        return val.replace(/,/g, '');
    } else {
        return val.replace(/\./g, '');
    }
};

seleccionarTodo(ev) {
    if(ev && ev['target'] && ev.target['select']){
        ev.target.select();
    }
}

limpiar() {
  this.listaProductosSeleccionados = []
  this.valorTotalVenta = 0
  this.valorTotalProductos = 0
  this.valorTotalImpuestos = 0
  this.realizandoUnaVenta = false
  this.valorTotalDevolver = 0
  this.clienteId = []
  this.clienteGenerico = undefined
  this.price = 0
  this.listaGruposProductos = []
  this.listaProductos = []
  this.clienteGenericoMesa = []
  this.actualizando = false
  this.datosDomicilio=[]
  this.datosDomicilioTotalDia = []
  this.maximopedido = 0
  this.minimopedido = 0
  this.totalpedido = 0
  this.domicilio = 'S'
  this.numeromesa = ''
  this.usuarios = []
  this.usuarioId = []
  this.imprimir= true


}
getMultiple(keys: string[]) {
  const promises = [];

  keys.forEach( key => promises.push(this.storage.get(key)) );

  return Promise.all(promises).then( values => {
    const result = {};

    values.map( (value, index) => {
      result[keys[index]] = value;
    });

    return result;
  });
}

public requestAutocompleteItems = (text: string): Observable<Response> => {
  return this.servicio.buscarClientesTelefonoPorCompania(text)
};

public requestAutocompleteUsuarioItems = (text: string): Observable<Response> => {
  return this.servicio.buscarUsuarioPorEmpresaFiltro(text)
};

public onTextChange(text) {
  console.log('text changed: value is ' + text);
}

comandaNoValida(){
  this.loader.dismiss()
  this.alertControllers.create({
      title:'Advertencia',
      message: 'No puede guardar la venta por que existen productos que no estan gestionados',
      buttons: ['ok']
}).present()
}



pagarDomicilio(){

  if( (this.valorTotalDevolver - this.valorTotalVenta) < 0 || isNaN(this.valorTotalDevolver)){
      this.mostrarMensajeDeError('Valor a devolver no valido!')
      return
  } else if ( this.valorTotalVenta <= 0){
      this.mostrarMensajeDeError('Valor total venta no valido!')
      return
  }

    let datosAdicionales = {
      valorTotalVenta: this.valorTotalVenta,
      totalPagado: this.valorTotalDevolver,
      valorTotalDevolver: (this.valorTotalDevolver - this.valorTotalVenta),
  }

  this.getMultiple(['usuariosId','companiasId'])
  .then( res => {

    datosAdicionales['usuariosId'] = res['usuariosId']
    datosAdicionales['companiasId'] = res['companiasId']

    if(datosAdicionales['usuariosId']==null){
        datosAdicionales['usuariosId'] = 1
    }
    // saber si tiene cliente seleccionado
    if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
        // envia el cliente que este seleccionado
        datosAdicionales['clientesId'] = this.clienteId[0]['value']
    } else if(this.clienteGenerico && this.clienteGenerico[0] && this.clienteGenerico[0]['clientesId']) {
        // si tiene un cliente generico seleccionado
        datosAdicionales['clientesId'] = this.clienteGenerico[0]['clientesId']
    } else {
        // envia un cliente null
        this.mostrarMensajes('Debe seleccionar un cliente','Advertencia')
        // datosAdicionales['clientesId'] = 0
    }


      // mostrar cargando
      this.loader = this.loaders.create({});
      this.loader.present();

      let busquedaGestion = 'G'
      // if( this.listaProductosSeleccionados.filter(e => e.estado.indexOf(busquedaGestion) != -1) ===undefined){
      //   this.mostrarMensajeGeneral('El domicilio aun no esta gestionado se inicia proceso de gestión...')
      //   this.enviarcomanda()
      // }
      let valoreslistaProductosSeleccionados  = this.listaProductosSeleccionados.filter(e => e.estado.indexOf(busquedaGestion) != -1)
      // if(valoreslistaProductosSeleccionados.length==0){
      //     this.comandaNoValida()
      //     return false
      // }
      // if(GESTION_DOMICILIOS){
      //   if(valoreslistaProductosSeleccionados.length < this.listaProductosSeleccionados.length){
      //     this.comandaNoValida()
      //     return false
      // }
      // }

      let codigo = valoreslistaProductosSeleccionados[0].codigo
      let cantidadActual =  valoreslistaProductosSeleccionados.length

      this.servicio.buscarComandasFacturaPorCompania(codigo)
      .subscribe((data)=>{
          let cantidadReal = data.length

          if(cantidadReal == cantidadActual){
            let elaboradosContenido = ''
              this.servicio.guardarVenta(this.listaProductosSeleccionados, datosAdicionales,elaboradosContenido,'').subscribe(
                  resVenta => {

                      this.loader.dismiss()

                          for(var k =0;k < valoreslistaProductosSeleccionados.length;k++){

                              // if(this.domicilio === valoreslistaProductosSeleccionados[k].numeromesa){
                                  let datosComanda = {
                                      comandasId: valoreslistaProductosSeleccionados[k].comandasId,
                                      estado: 'F',
                                      imagen: null,
                                      color: '#006400',
                                      queHago: "A",
                                      nombreTabla: "comandas",
                                      name: "dataDynamicCrud"

                                    }
                                    this.servicio.actualizarComandas(datosComanda)
                                    .subscribe((data)=>{
                                      this.iniciar()
                                      console.log(data)
                                    },(error)=>{
                                      this.iniciar()
                                        console.log(error)
                                    })
                              // }
                          }

                          this.iniciar()
                          this.mostrarMensajeGeneral(resVenta.json())
                  },
                  errVenta => {

                      this.loader.dismiss()
                      this.iniciar()
                      this.mostrarMensajeDeError('Error Guardando Venta')
                  }
              )
          }else{
              this.comandaNoValida()
          }
      },(error)=> console.log(error))

  })

}

mostrarMensajeGeneral(mensaje) {
  let recibo = ''


  if(MODO_DESCONECTADO){
      for (let index:any = 0; index < mensaje.length; index++) {
          recibo += mensaje[index]['reciboCaja'] + '\n'
      }
  }else{
      if(mensaje && mensaje[0] && mensaje[0][0]){
          let mensajes = mensaje[0]
          for (let index:any = 0; index < mensajes.length; index++) {
              recibo += mensajes[index]['reciboCaja'] + '\n'
          }
      }
  }

  // limpiar todo el formulario
  this.limpiar()
  this.iniciar()
  // mandar a imprimir
  this.servicio.imprimirRecibo(recibo).subscribe(
      res => {

      },
      err => {
          // si hay errores y no pudo imprimir debe guardar el archivo o seleccionar otra impresora
          if(this.platform.is('android') || this.platform.is('ios')){
              // var mywindow = window.open('', 'PRINT', 'height=400,width=600');
              // mywindow.document.write('<html><head><title>venta</title>');
              // mywindow.document.write('</head><body >');
              // mywindow.document.write(recibo);
              // mywindow.document.write('</body></html>');
              // mywindow.document.close(); // necessary for IE >= 10
              // mywindow.focus(); // necessary for IE >= 10*/
              // mywindow.print();
              // mywindow.close();
              this.mostrarMensajeExito(' '+ recibo)
          }else{
              let alert = this.alertControllers.create({
                  title: '',
                  subTitle: recibo,
                  buttons: ['Cerrar']
              });
              alert.present();

              // si hay errores imprimiendo
              // var mywindow = window.open('', 'PRINT', 'height=400,width=600');
              // mywindow.document.write('<html><head><title>venta</title>');
              // mywindow.document.write('</head><body >');
              // mywindow.document.write(recibo);
              // mywindow.document.write('</body></html>');
              // mywindow.document.close(); // necessary for IE >= 10
              // mywindow.focus(); // necessary for IE >= 10*/
              // // mywindow.print();
              // mywindow.close();
          }

      }
  )


}

mostrarMensajeExito(mensaje) {
  let alert = this.alertControllers.create({
    title: 'Registro generado con exito',
    subTitle: mensaje,
    buttons: ['Cerrar']
  });
  alert.present();
}


enviarcomanda() {

   if ( this.valorTotalVenta <= 0){
      this.mostrarMensajeDeError('Valor total venta no valido!')
      return
  }

  let datosAdicionales = {
      valorTotalVenta: this.valorTotalVenta,
      totalPagado: this.valorTotalDevolver,
      valorTotalDevolver: (this.valorTotalDevolver - this.valorTotalVenta),
  }

  this.getMultiple(['usuariosId','companiasId'])
  .then( res => {

      if (this.usuarioId && this.usuarioId[0] && this.usuarioId[0]['value']) {
        datosAdicionales['usuariosId'] = this.usuarioId[0]['value']
      }else{
        datosAdicionales['usuariosId'] = this.usuarios['usuariosId']
        // this.mostrarMensajes('Debe ingresar el usuario','Verifique')
        // return false
      }

      datosAdicionales['companiasId'] = res['companiasId']

      if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {

          datosAdicionales['clientesId'] = this.clienteId[0]['value']
      } else if(this.clienteGenerico && this.clienteGenerico[0] && this.clienteGenerico[0]['clientesId']) {

          datosAdicionales['clientesId'] = this.clienteGenerico[0]['clientesId']
      } else {

          datosAdicionales['clientesId'] = 0
      }

      if(datosAdicionales['clientesId'] ==0 && this.domicilio =="S"){
        this.mostrarMensajes('Debe ingresar el cliente','Verifique')
        return false
      }

      let fechaHoy = new Date()
      let nuevafechaIngreso = fechaHoy.toLocaleDateString()
      nuevafechaIngreso = nuevafechaIngreso.split('/').reverse().join('-')
      let fecha = this.formatearCadena(nuevafechaIngreso)
      let uuid = UUID.UUID();

      let valorTotalDevolver = (this.valorTotalDevolver - this.valorTotalVenta)
      let nuevoArray = []

      for(var k =0;k < this.listaProductosSeleccionados.length;k++){
        this.listaProductosSeleccionados[k]['numeromesa'] = this.numeromesa
        this.listaProductosSeleccionados[k]['clientesId'] = datosAdicionales['clientesId']
        this.listaProductosSeleccionados[k]['companiasId'] = datosAdicionales['companiasId']
        this.listaProductosSeleccionados[k]['usuariosId'] = datosAdicionales['usuariosId']
        this.listaProductosSeleccionados[k]['valorTotalVenta'] = this.valorTotalVenta
        // this.listaProductosSeleccionados[k]['totalPagado'] = this.valorTotalDevolver
        this.listaProductosSeleccionados[k]['totalPagado'] = 0
        // this.listaProductosSeleccionados[k]['valorTotalDevolver'] = valorTotalDevolver
        this.listaProductosSeleccionados[k]['valorTotalDevolver'] = 0
        this.listaProductosSeleccionados[k]['fecha'] = fecha
        this.listaProductosSeleccionados[k]['domicilio'] = this.domicilio
        if(GESTION_DOMICILIOS){
          this.listaProductosSeleccionados[k]['estado'] = this.listaProductosSeleccionados[k]['estado'] == undefined ? 'P' : this.listaProductosSeleccionados[k]['estado']
        }else{
          this.listaProductosSeleccionados[k]['estado'] = 'G'
        }

        this.listaProductosSeleccionados[k]['Uuid'] = uuid
        let Uuid = `${this.listaProductosSeleccionados[k]['Uuid'].substr(0,6)}-${datosAdicionales['companiasId']}`
        if(this.actualizando){
          Uuid = this.listaProductosSeleccionados[0]['codigo']
        }
        this.listaProductosSeleccionados[k]['codigo'] = Uuid
        if(this.listaProductosSeleccionados[k]['centroDeCostosId']=="0"){
          this.listaProductosSeleccionados[k]['centroDeCostosId'] = 0
        }
        if(GESTION_DOMICILIOS){
          if(this.listaProductosSeleccionados[k]['estado'] == "P" && this.listaProductosSeleccionados[k]['tipoProducto'] == "P" ){
            this.listaProductosSeleccionados[k]['color'] ="#F08080"
          }else{
            if(this.listaProductosSeleccionados[k]['estado'] == "P" && this.listaProductosSeleccionados[k]['tipoProducto'] == "E" ){
              this.listaProductosSeleccionados[k]['color'] =" #FAEBD7"
            }
          }
        }else{
          this.listaProductosSeleccionados[k]['color'] = "#006400"
          this.listaProductosSeleccionados[k]['estado'] = "G"
        }

        // if(this.listaProductosSeleccionados[k]['estado'] == "P" && this.listaProductosSeleccionados[k]['tipoProducto'] == "P" ){
        //   this.listaProductosSeleccionados[k]['color'] ="#F08080"
        // }else{
        //   if(this.listaProductosSeleccionados[k]['estado'] == "P" && this.listaProductosSeleccionados[k]['tipoProducto'] == "E" ){
        //     this.listaProductosSeleccionados[k]['color'] =" #FAEBD7"
        //   }
        // }


       //
        // this.listaProductosSeleccionados[k]['valorProducto'] =

        if(this.listaProductosSeleccionados[k]['imagen']==null){
          this.listaProductosSeleccionados[k]['imagen']= "https://res.cloudinary.com/drqk6qzo7/image/upload/v1517108463/Sin_imagen_disponible_gsghfo.jpg"
        }

        let valorImpuesto = 0
        valorImpuesto = this.listaProductosSeleccionados[k]['queHago'] !== undefined ?
          parseInt(this.listaProductosSeleccionados[k]['valorImpuesto']) * parseInt(this.listaProductosSeleccionados[k]['cantidad']) :
          parseInt(this.listaProductosSeleccionados[k]['valorImpuesto'])
        let valorProducto = 0
        valorProducto = this.listaProductosSeleccionados[k]['queHago'] !== undefined ?
        parseInt(this.listaProductosSeleccionados[k]['valorProducto']) * parseInt(this.listaProductosSeleccionados[k]['cantidad']) :
        parseInt(this.listaProductosSeleccionados[k]['valorProducto'])
        nuevoArray.push({
          'cantidad': parseInt(this.listaProductosSeleccionados[k]['cantidad']),
          'gruposProductosId': this.listaProductosSeleccionados[k]['gruposProductosId'],
          'imagen': this.listaProductosSeleccionados[k]['imagen'],
          'nombreProducto': this.listaProductosSeleccionados[k]['nombreProducto'],
          'numeromesa': (this.listaProductosSeleccionados[k]['numeromesa'] == undefined || this.listaProductosSeleccionados[k]['numeromesa'] == '') ? 100 : this.listaProductosSeleccionados[k]['numeromesa'],
          'productosId': this.listaProductosSeleccionados[k]['productosId'],
          'tipoProducto': this.listaProductosSeleccionados[k]['tipoProducto'],
          'valorImpuesto': valorImpuesto,
          'valorProducto': valorProducto,
          'valorVenta': parseInt(this.listaProductosSeleccionados[k]['valorVenta']),
          'clientesId': this.listaProductosSeleccionados[k]['clientesId'],
          'companiasId': this.listaProductosSeleccionados[k]['companiasId'],
          'totalPagado': this.listaProductosSeleccionados[k]['totalPagado'],
          'usuariosId': this.listaProductosSeleccionados[k]['usuariosId'],
          'valorTotalDevolver': this.listaProductosSeleccionados[k]['valorTotalDevolver'],
          'valorTotalVenta': this.listaProductosSeleccionados[k]['valorTotalVenta'],
          'centroDeCostosId': this.listaProductosSeleccionados[k]['centroDeCostosId'],
          'codigoCentroDeCosto': this.listaProductosSeleccionados[k]['codigoCentroDeCosto'],
          'fecha': this.listaProductosSeleccionados[k]['fecha'],
          'domicilio': this.listaProductosSeleccionados[k]['domicilio'],
          'estado': this.listaProductosSeleccionados[k]['estado'],
          'Uuid': this.listaProductosSeleccionados[k]['Uuid'],
          'codigo': this.listaProductosSeleccionados[k]['codigo'],
          'color': this.listaProductosSeleccionados[k]['color'],
          'descripcion': this.descripcion
        })


      }

      let codigo = nuevoArray[0]['codigo']
      console.log(nuevoArray)
      let a = JSON.stringify(nuevoArray)
      // this.mostrarMensajes('datos...', a + codigo)

      this.descripcion = ""
      this.servicio.guardarComandas(nuevoArray,codigo)
      .subscribe((data)=>{

        let datos = data
        let valores =JSON.parse(datos['_body'])
        this.enviarMensaje('comanda-generada',valores)
        let mensaje = `Verifique la comanda según el centro de costo`
        // this.servicio.genearNotificacionComandas('Comanda cargada',mensaje)
        // .subscribe(()=>{},error=>{console.log('generando comanda')})


        this.mostrarMensajes('Su comanda fue generada...','Registro exitoso')
        this.actualizarData('','true')
        this.iniciar()
      }, error => {

        this.mostrarMensajeDeError('No se pudo guardar la comanda verifique...')
      })


  })
}

editarComanda(item:any, index){

  item['queHago'] = "A",
  item['nombreTabla'] = "comandas"
  item['name'] = "dataDynamicCrud"
  item['color'] = "#006400"
  item['estado'] = "G"
  // item['valorImpuesto'] = this.valorTotalImpuestos * item.cantidad
  // item['valorProducto'] = this.valorTotalProductos * item.cantidad
  // item['valorTotalVenta'] = this.valorTotalVenta

  let id = item['comandasId']

  this.servicio.buscarComandasPorId(id).subscribe((val)=>{

      let cantidad = item['cantidad']
      let cantidadReal = 0
      cantidadReal = Number(val[0].cantidad)
      if(cantidad>cantidadReal){
        this.listaProductosSeleccionados[index]['cantidad'] = cantidad
        let valorImpuesto = Number(val[0].valorImpuesto) / cantidadReal
        let valorVenta = Number(val[0].valorVenta)
        valorVenta = valorVenta - valorImpuesto

        this.valorTotalImpuestos = valorImpuesto * cantidad
        item['valorImpuesto'] = this.valorTotalImpuestos
        item['valorProducto'] = valorVenta * cantidad
        item['valorTotalVenta'] = this.valorTotalVenta
        this.valorTotalImpuestos = 0
        this.valorTotalVenta = 0
        this.listaProductosSeleccionados = []
      }else{
        if(cantidad <= 0){
            this.listaProductosSeleccionados.splice(index, 1)

            if(this.listaProductosSeleccionados.length <= 0){
                this.realizandoUnaVenta = false
                this.actualizando = false
            }
        }else{
            this.listaProductosSeleccionados[index]['cantidad'] = cantidad
        }
            this.listaProductosSeleccionados[index]['cantidad'] = cantidad
            let valorImpuesto = Number(val[0].valorImpuesto) / cantidadReal
            let valorVenta = Number(val[0].valorVenta)
            valorVenta = valorVenta - valorImpuesto

            this.valorTotalImpuestos = valorImpuesto * cantidad
            item['valorImpuesto'] = this.valorTotalImpuestos
            item['valorProducto'] = valorVenta * cantidad
            item['valorTotalVenta'] = this.valorTotalVenta
            this.valorTotalImpuestos = 0
            this.valorTotalVenta = 0
            this.listaProductosSeleccionados = []
      }

    this.servicio.actualizarComandas(item).subscribe((val)=>{
      console.log(val)
      let id = Number(val['_body'])
      // this.servicio.buscarComandasPorId(id).subscribe((val)=>{
      //   this.listaProductosSeleccionados = val[0]
      // })
      // this.actualizarData('','false')

      this.iniciar()

    })

  })


  // this.servicio.genearNotificacionComandas("notificaciones","notificación generada")
  // .subscribe((data)=>{
  //   console.log(data)
  // },error =>{
  //   console.log(error)
  // })
}

cancelarComanda(item:any){

  item['queHago'] = "A",
  item['nombreTabla'] = "comandas",
  item['name'] = "dataDynamicCrud"
  item['color'] = "#FF0000"
  item['estado'] = "C"

  this.numeromesa = item.numeromesa
  let numeromesa = this.numeromesa
  let codigo = item.codigo
  let mensaje = `Mesa ${numeromesa} código comanda ${codigo}`
  this.servicio.cancelarComandas(item).subscribe(()=>{
    this.traerDatosGuardados(this.numeromesa)
    this.limpiar()
  })

  // this.servicio.genearNotificacionComandas('Comanda cancelada',mensaje)
  // .subscribe(()=>{},error=>{console.log('la genero')})

}
formatearCadena(cadena){
  let valorinicial = cadena.length
  let primero,segundo,ultimo
  primero = cadena.substr(0,4)
  segundo = cadena.substr(5,2)
  ultimo = cadena.substr(valorinicial - 2, valorinicial)
  if(valorinicial != 10){
    let recorrer = cadena.split('-')
    for(var i = 0; i < recorrer.length;i++) {
      if(i == 1 && recorrer[i].length == 1) {
        segundo = `0${recorrer[i]}`
      }
      if(i == 2 && recorrer[i].length == 1){
        ultimo = `0${recorrer[i]}`
      }
    }
  }
  return `${primero}-${ultimo}-${segundo}`
}

cerrarSession(){
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}
}



// WEBPACK FOOTER //
// ./src/pages/domicilios/domicilios.ts